import { style } from '@vanilla-extract/css';

export const survey = style({
  padding: 'var(--padding)',

  '@media': {
    'only screen and (--mobile)': {
      padding: 'var(--mobile-padding)',
    },
  },
});

export const inputStyle = style({
  borderRadius: 'var(--input-border-radius)',
  borderWidth: 'var(--input-border-width)',
  borderColor: 'var(--input-border-color)',
  borderStyle: 'var(--input-border-style)',
  backgroundColor: 'var(--input-background-color)',
  color: 'var(--input-text-color)',
  fontFamily: 'var(--input-text-font-family)',
  fontSize: 'var(--input-text-font-size)',
  '::placeholder': {
    textAlign: 'var(--text-align)',
    color: 'var(--input-placeholder-color)',
  },
  selectors: {
    '&[data-placeholder-selected="true"]': {
      color: 'var(--input-placeholder-color)',
    },
  },
});

export const titleStyle = style({
  color: 'var(--title-color)',
  fontFamily: 'var(--title-font-family)',
});

export const descriptionStyle = style({
  color: 'var(--description-color)',
  fontFamily: 'var(--description-font-family)',
});

export const questionStyle = style({
  display: 'block',
  fontSize: 'var(--question-label-font-size, 1rem)',
  fontWeight: 'var(--question-label-font-weight, 500)',
  lineHeight: '1.5rem',
  color: 'var(--question-label-color)',
  fontFamily: 'var(--question-label-font-family)',
  padding: '0px',
  cursor: 'pointer',
});

export const helperTextStyle = style({
  fontSize: '0.875rem',
  fontWeight: '500',
  lineHeight: '1.5rem',
  color: 'var(--helper-text-color)',
  padding: '0px',
  cursor: 'pointer',
  fontFamily: 'var(--helper-text-font-family)',
});

export const radioStyle = style({
  appearance: 'none',
  width: '16px',
  height: '16px',
  // !important is required to override Tailwind's base [type=radio] styles
  // In production builds, CSS load order differs from dev, causing Tailwind to load last
  borderColor: 'var(--border-color)!important',
  borderWidth: 'var(--border-width)!important',
  borderStyle: 'solid',
  display: 'inline-block',
  borderRadius: '50%',
  cursor: 'pointer',
  position: 'relative',
  gap: '4px',
  fontFamily: 'var(--input-text-font-family)',

  selectors: {
    '&:checked': {
      backgroundColor: 'var(--border-color)!important',
      borderColor: 'var(--border-color)!important',
      backgroundImage: 'none!important',
    },
    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'var(--radio-checked-dot-color, #000)',
    },
  },
});

export const buttonStyle = style({
  width: '100%',
  padding: '8px 16px',
  borderRadius: 'var(--border-radius, 6px)',
  backgroundColor: 'var(--button-color, #000000)',
  color: 'var(--button-text-color, #ffffff)',
  fontFamily: 'var(--button-text-font-family)',
  fontSize: '1rem',
  fontWeight: '500',
  lineHeight: '1.5rem',
  cursor: 'pointer',
});
